import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-one-one-one',
  templateUrl: './c5-five-one-one-one.component.html',
  styleUrls: ['./c5-five-one-one-one.component.scss']
})
export class C5FiveOneOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
